import { z } from 'zod';

export const V1BiomarkersResponseSchema = z
  .object({
    timestamp_epoch: z.number(),
    timestamp: z.coerce.date(), // assumes you'll be providing actual Date objects for validation
    heart_rate: z.number(),
    respiratory_rate: z.number().nullable(),
    heart_rate_variability: z.number().nullable(),
    ans_balance: z.number().nullable(),
    resonant_breathing_score: z.number().nullable(),
    morning_readiness: z.number().nullable(),
    acute_mental_stress_score: z.number().nullable(),
    mental_health_risk: z.number().nullable(),
    patient: z.string().nullable(),
    performer: z.string().nullable(),
  })
  .transform((o) => ({
    ...o,
    epoch: o.timestamp_epoch,
  }));

export type V1BiomarkersResponse = z.infer<typeof V1BiomarkersResponseSchema>;

export const V1UnprocessableVideoResponseSchema = z.object({
  errorCode: z.number(),
  errorType: z.string().nullable(),
  errorDescription: z.string().nullable(),
});

export type V1UnprocessableVideoResponse = z.infer<typeof V1UnprocessableVideoResponseSchema>;
